import ApiHttp from '../http';
import {Regions} from '../../model';

class RegionService {

    /**
     * Service for interacting with the movies api
     */
    constructor() {
        this.regions = undefined;
        this.regionsDictionary = undefined;
    }

    setPreRenderRegions(raw_data) {
        if(raw_data && raw_data != undefined) {
            this.regions = new Regions(raw_data)
        } else {
            this.regions = undefined
        }

        return this.regions
    }

    setPreRenderRegionsDictionary(raw_data) {
        if(raw_data && raw_data != undefined) {
            this.regionsDictionary = raw_data
        } else {
            this.regionsDictionary = undefined
        }

        return this.regionsDictionary
    }

    /**
     *
     * @returns {Promise.<Movies>|*}
     */
    getRegions() {
        return this.regions = this.regions || ApiHttp.get(`/regions`).then(
                (response) => {
                    return new Regions(response.data)
                }, 
                (error) => {
                    this.regions = undefined;
                    return Promise.reject(error)
                })
    }

    getRegionsDictionary() {
        return this.regionsDictionary = this.regionsDictionary || ApiHttp.get(`/regions/cinemas`).then(
                (response) => {
                    return response.data
                }, 
                (error) => {
                    this.regionsDictionary = undefined;
                    return Promise.reject(error)
                })
    }

    getCinemasNearBy(lat, long) {
        return this.getRegions().then((regions)=>regions.cinemasCloseTo(lat, long)).then((regions) => {
            // console.log("region service getCinemasNearBy",regions)
            return regions    
        })
        
        
    }

    getCinema(id){
      return   this.getRegions().then((regions)=> regions.findCimema(id));
    }

    getCinemaBySlug(slug) {
        if(slug && slug.length > 0)
            return this.getRegions().then((regions) => regions.findCinemaBySlug(slug));
        else 
            return null;
    }

    getPrerederedCinemaBySlug(regions, slug) {
        if(slug && slug.length > 0)
            return regions.findCinemaBySlug(slug)
        else
            return null
    }

    getRegionsForSelectedCinemaType(regions, movies, selected_types) {
        // console.log("movies", movies);

        if(!selected_types || selected_types.length == 0) {
            return {cinemas: regions, movies: movies}
        }

        let moviesWithTypes = []
        for(let t in selected_types) {
            for(let m in movies) {

                if(movies[m].experiences.includes(selected_types[t].name)) {
                    
                    let exists = false;
                    if(moviesWithTypes.length > 0) {
                        for(let mt in moviesWithTypes) {
                            if(movies[m].id == moviesWithTypes[mt].id) {
                                exists = true;
                            }
                        }
                    }

                    if(!exists) {
                        moviesWithTypes.push(movies[m]);
                    }
                }
            }
        }

        //get unique cinema ids for the selected cinema types from movies sessions
        let cinemasWithType = []
        for(let m in moviesWithTypes) {
            for(let c in moviesWithTypes[m].cinemas) {
                for(let t in selected_types) {
                    for(let s in moviesWithTypes[m].cinemas[c]) {
                        for(let e in moviesWithTypes[m].cinemas[c][s].experiences) {

                            let exists = false;
                            if(selected_types[t].name == moviesWithTypes[m].cinemas[c][s].experiences[e].name) {
                                if(cinemasWithType.length > 0) {
                                    for(let ct in cinemasWithType) {
                                        if(c == cinemasWithType[ct]) {
                                            exists = true;
                                        }
                                    }
                                }

                                if(!exists) {
                                    cinemasWithType.push(c)
                                }
                            }
                        }
                    }
                }
            }
        }

        return {cinemas: cinemasWithType, movies: moviesWithTypes};
    }

    getRegionsForSelectedTime(regions, movies, selected_time) {
        if(!selected_time) {
            return {cinemas: regions, movies: movies}
        }

        let moviesWithTime = []
        for(let m in movies) {
            // console.log(movies[m])
            for(let t in movies[m].time_tags) {
                // console.log(selected_time.hour, movies[m].time_tags[t], movies[m].time_tags[t].includes(selected_time.hour+":"))

                if(movies[m].time_tags[t].includes(selected_time.hour+":")) {
                    let exists = false;
                    if(moviesWithTime.length > 0) {
                        for(let mt in moviesWithTime) {
                            if(movies[m].id == moviesWithTime[mt].id) {
                                exists = true;
                            }
                        }
                    }

                    if(!exists) {
                        moviesWithTime.push(movies[m]);
                    }    
                }
            }
        }

        // console.log("Movies with time", moviesWithTime)

        let cinemasWithTime = []
        for(let m in moviesWithTime) {
            for(let c in moviesWithTime[m].cinemas) {
                for(let s in moviesWithTime[m].cinemas[c]) {
                    // console.log(moviesWithTime[m].cinemas[c][s].time_tag.includes(selected_time.hour+":"))

                    let exists = false;
                    if(moviesWithTime[m].cinemas[c][s].time_tag.includes(selected_time.hour+":")) {
                        if(cinemasWithTime.length > 0) {
                            for(let ct in cinemasWithTime) {
                                if(c == cinemasWithTime[ct]) {
                                    exists = true;
                                }
                            }
                        }

                        if(!exists) {
                            cinemasWithTime.push(c)
                        }
                    }
                }
            }
        }

        return {cinemas: cinemasWithTime, movies: moviesWithTime}
    }

    getCinemasFromIds(ids) {
        // console.log("getCinemasFromIds", ids)
       return Promise.resolve(this.getRegions()).then((region_data) => {
            let regions = region_data.data
            let available_cinemas = []
            for(let r in regions) {
                // console.log(regions[r])
                for(let c in regions[r].cinemas) {
                    // console.log(regions[r].cinemas[c])
                    // console.log(ids)
                    for(let i in ids) {
                        let exists = false
                        if(ids[i] == regions[r].cinemas[c].id) {
                            
                            if(available_cinemas.length > 0) {
                                for(let a in available_cinemas) {
                                    if(available_cinemas[a].id == regions[r].cinemas[c].id) {
                                        exists = true
                                    }
                                }
                            }

                            if(!exists) {
                                available_cinemas.push(regions[r].cinemas[c])
                            }
                        }
                    }
                }
            }

            return available_cinemas
        })
    }

    strictMergeCinemaIds(cinemasByType, cinemasByTime) {

        let cinemas = []
        if(cinemasByType.length > 0 && cinemasByTime.length > 0) {
            // console.log("merge type and time")
            for(let ty in cinemasByType) {
                for(let ti in cinemasByTime) {
                    let exists = false
                    if(cinemasByTime[ti].id == cinemasByType[ty].id) {
                        // console.log("match",cinemasByType[ty], cinemasByTime[ti])
                        if(cinemas.length > 0) {
                            for(let c in cinemas) {
                                if(cinemas[c].id == cinemasByType[ty].id) {
                                    exists = true
                                }
                            }
                        }

                        if(!exists) {
                            cinemas.push(cinemasByType[ty])
                        }
                    }
                }
            }
        } else if(cinemasByType.length == 0 && cinemasByTime.length > 0) {
            // console.log("return time", cinemasByTime)
            cinemas = cinemasByTime
        } else if(cinemasByType.length > 0 && cinemasByTime.length == 0) {
            // console.log("return type", cinemasByType)
            cinemas = cinemasByType
        }

        return cinemas
    }

    getAllCinemas(regions, movies) {
        let cinema_ids = []
        for(let m in movies) {
            for(let c in movies[m].cinemas) {
                for(let s in movies[m].cinemas[c]) {
                    let exists = false;
                    // console.log(movies[m].cinemas[c][s])
                    if(cinema_ids.length > 0) {
                        for(let ci in cinema_ids) {
                            if(cinema_ids[ci] == movies[m].cinemas[c][s].cinema_id) {
                                exists = true
                            }
                        }
                    }

                    if(!exists) {
                        cinema_ids.push(movies[m].cinemas[c][s].cinema_id)
                    }
                }
            }
        }

        let cinemas = []
        for(let r in regions) {
            // console.log("region",regions[r])
            for(let c in regions[r].cinemas) {
                for(let ci in cinema_ids) {
                    if(regions[r].cinemas[c].id == cinema_ids[ci]) {
                        let exists = false;

                        if(cinemas.length > 0) {
                            for(let cc in cinemas) {
                                if(cinemas[cc] == regions[r].cinemas[c].id) {
                                    exists = true
                                }
                            }
                        }

                        if(!exists) {
                            cinemas.push(regions[r].cinemas[c])
                        }
                    }
                }
            }
        }

        return cinemas
    }

    getRegionsForSelectedGenres(cinemas, movies, selected_genres) {
        // console.log("selected_genres",selected_genres)
        if(!selected_genres || selected_genres.length == 0) {
            return {cinemas: cinemas, movies: movies}
        }

        let moviesWithGenres = []
        for(let m in movies) {
            for(let g in movies[m].genres) {
                for(let sg in selected_genres) {
                    let exists = false
                    if(selected_genres[sg].id == movies[m].genres[g].id) {
                        if(moviesWithGenres.length > 0) {
                            for(let mwg in moviesWithGenres) {
                                if(moviesWithGenres[mwg].id == movies[m].id) {
                                    exists = true
                                }
                            }
                        }

                        if(!exists) {
                            moviesWithGenres.push(movies[m])
                        }
                    }
                }
            }
        }

        // console.log("moviesWithGenres", moviesWithGenres)
        let cinemasWithGenres = []
        for(let c in cinemas) {
            for(let m in moviesWithGenres) {
                for(let mc in moviesWithGenres[m].cinemas) {
                    for(let s in moviesWithGenres[m].cinemas[mc]) {
                        let exists = false;

                        if(moviesWithGenres[m].cinemas[mc][s].cinema_id == cinemas[c]) {
                            if(cinemasWithGenres.length > 0) {
                                for(let cg in cinemasWithGenres) {
                                    if(cinemasWithGenres[cg] == cinemas[c]) {
                                        exists = true
                                    }
                                }
                            }

                            if(!exists) {
                                cinemasWithGenres.push(cinemas[c])
                            }
                        }
                    }
                }
            }
        }

        // console.log("cinemasWithGenres", cinemasWithGenres)

        return {cinemas:cinemasWithGenres, movies: moviesWithGenres}
    }

    getAvailableRegionsForFilterSelection(movies, selected_cinema, selected_types, selected_genres, selected_time) {

        return Promise.resolve(this.getRegions()).then((regions) => {
            return Promise.resolve(this.getAllCinemas(regions.data, movies)).then((all_cinemas) => {
                // console.log("all_cinemas", all_cinemas)
                return Promise.resolve(this.getRegionsForSelectedTime(all_cinemas, movies, selected_time)).then((data_with_time) => {
                    // console.log("selected_genres", selected_genres)
                    // console.log("data_with_time", data_with_time)

                    return Promise.resolve(this.getRegionsForSelectedGenres(data_with_time.cinemas, data_with_time.movies, selected_genres)).then((data_with_genres) => {
                        // console.log("data_with_genres", data_with_genres)
                        
                        return Promise.resolve(this.getRegionsForSelectedCinemaType(data_with_genres.cinemas, data_with_genres.movies, selected_types)).then((data_with_type) => {
                            // console.log("data_with_type", data_with_type)
                            return Promise.resolve(this.getCinemasFromIds(data_with_type.cinemas)).then((cinemas) => {
                                // console.log("cinemas", cinemas)
                                return cinemas
                            })
                            
                        })
                    })
                    
                })
            })
        })
    }

    generateTimeRanges(movies) {
            
        var time_tags = []
        for(let m in movies) {
            for(let t in movies[m].time_tags) {
                time_tags.push(movies[m].time_tags[t])
            }
        }

        // console.log("time tags", time_tags)

        var unique = [...new Set(time_tags)];
        var time_ranges = [];

        for(var i = 1; i <= 24; i++) {
            var hour = 0;
            var next_hour = 0;
            if(i < 10) {
                hour = "0"+i;
                if(i < 9) {
                    next_hour = "0"+(i+1);
                } else {
                    next_hour = (i+1);
                }
            } else {
                hour = i;
                if(i == 23) {
                    next_hour = "00";
                } else if(i == 24) {
                    hour = "00";
                    next_hour = "01";
                } else {
                    next_hour = (i+1);
                }
                
            }

            let partial_time = hour+":";
            var range = hour+":00 - "+next_hour+":00";
            var has_time_slot = false;
            for(let t in unique) {
                if(unique[t].includes(partial_time)) {
                    has_time_slot = true;
                    break;
                }
            }

            if(has_time_slot) {
                time_ranges.push({"range":range, "hour": hour});
            }
        }

        let timeRanges = {name: "Times available for selection:", items: time_ranges}
        return timeRanges;
    }

    getMoviesWithSelectedCinema(movies, cinema) {

        if(!cinema) {
            return {movies: movies}
        }

        let moviesWithCinema = []
        for(let m in movies) {
            for(let c in movies[m].cinemas) {
                for(let s in movies[m].cinemas[c]) {

                    let exists = false
                    if(movies[m].cinemas[c][s].cinema_id == cinema.id) {
                        if(moviesWithCinema.length > 0) {
                            for(let mc in moviesWithCinema) {
                                if(moviesWithCinema[mc].id == movies[m].id) {
                                    exists = true
                                }
                            }
                        }

                        if(!exists) {
                            moviesWithCinema.push(movies[m])
                        }
                    }
                }
            }
        }

        return {movies: moviesWithCinema}
    }

    getMoviesWithSelectedCinemaTypes(movies, types) {
        
        if(!types || types.length == 0) {
            return {movies: movies}
        }

        let moviesWithTypes = []
        for(let m in movies) {
            // console.log(movies[m])
            for(let c in movies[m].cinemas) {
                for(let s in movies[m].cinemas[c]) {
                    for(let e in movies[m].cinemas[c][s].experiences) {
                        for(let t in types) {
                            let exists = false
                            if(types[t].name == movies[m].cinemas[c][s].experiences[e].name) {
                                if(moviesWithTypes.length > 0) {
                                    for(let mt in moviesWithTypes) {
                                        if(moviesWithTypes[mt].id == movies[m].id) {
                                            exists = true
                                        }
                                    }
                                }

                                if(!exists) {
                                    moviesWithTypes.push(movies[m])
                                }
                            }
                        }

                    }
                }
            }
        }

        return {movies: moviesWithTypes}
    }

    getMoviesWithSelectedTime(movies, selected_time) {
        // console.log(movies)
        // console.log(selected_time)

        if(!selected_time || selected_time.length == 0) {
            return {movies: movies}
        }

        let moviesWithTime = []
        for(let m in movies) {
            // console.log(movies[m])
            for(let c in movies[m].cinemas) {
                for(let s in movies[m].cinemas[c]) {
                    let exists = false
                    if(movies[m].cinemas[c][s].time_tag.includes(selected_time.hour+":")) {
                        if(moviesWithTime.length > 0) {
                            for(let mt in moviesWithTime) {
                                if(moviesWithTime[mt].id == movies[m].id) {
                                    exists = true
                                }
                            }
                        }

                        if(!exists) {
                            moviesWithTime.push(movies[m])
                        }
                    }
                }
            }
        }

        return {movies: moviesWithTime}
    }

    getMoviesWithSelectedGenres(movies, selected_genres) {
        if(!selected_genres || selected_genres.length == 0) {
            return {movies: movies}
        }

        let moviesWithGenres = []
        for(let m in movies) {
            for(let g in movies[m].genres) {
                for(let sg in selected_genres) {
                    let exists = false
                    if(selected_genres[sg].id == movies[m].genres[g].id) {
                        if(moviesWithGenres.length > 0) {
                            for(let mwg in moviesWithGenres) {
                                if(moviesWithGenres[mwg].id == movies[m].id) {
                                    exists = true
                                }
                            }
                        }

                        if(!exists) {
                            moviesWithGenres.push(movies[m])
                        }
                    }
                }
            }
        }

        return {movies: moviesWithGenres}
    }

    getCinemaTypesFromMovies(movies, meta) {
        let mtypes = meta.experiences
        let cinemaTypes = []

        for(let m in movies) {
            for(let c in movies[m].cinemas) {
                for(let s in movies[m].cinemas[c]) {
                    for(let e in movies[m].cinemas[c][s].experiences) {
                        for(let mt in mtypes) {
                            let exists = false

                            if(mtypes[mt].name == movies[m].cinemas[c][s].experiences[e].name) {
                                if(cinemaTypes.length > 0) {
                                    for(let ct in cinemaTypes) {
                                        if(cinemaTypes[ct].name == mtypes[mt].name) {
                                            exists = true
                                        }
                                    }
                                }

                                if(!exists) {
                                    cinemaTypes.push(movies[m].cinemas[c][s].experiences[e])
                                }
                            }
                        }
                    }
                }
            }
        }

        return cinemaTypes
    }

    getGenresFromMovies(movies, meta) {
        let mgenres = meta.genres
        let genres = []

        for(let m in movies) {
            for(let g in movies[m].genres) {
                for(let mg in mgenres) {
                    let exists = false

                    if(mgenres[mg].name == movies[m].genres[g].name) {
                        if(genres.length > 0) {
                            for(let ag in genres) {
                                if(genres[ag].name == mgenres[mg].name) {
                                    exists = true
                                }
                            }
                        }

                        if(!exists) {
                            genres.push(movies[m].genres[g])
                        }
                    }
                }
            }
        }

        return genres
    }

    generateAvailableTimeRangesForFilterSelection(movies, selected_cinema, selected_types, selected_genres, time_ranges) {
        
        return Promise.resolve(this.getMoviesWithSelectedCinema(movies, selected_cinema)).then((data_with_cinema) => {
            // console.log("data_with_cinema", data_with_cinema)
            return Promise.resolve(this.getMoviesWithSelectedCinemaTypes(data_with_cinema.movies, selected_types)).then((data_with_type) => {
                // console.log("data_with_type", data_with_type)
                return Promise.resolve(this.getMoviesWithSelectedGenres(data_with_type.movies, selected_genres)).then((data_with_genres) => {
                    // console.log("data_with_genres", data_with_genres)
                    return Promise.resolve(this.generateTimeRanges(data_with_genres.movies)).then((time_ranges) => {
                        // console.log("generated_time_ranges", time_ranges)
                        return time_ranges
                    })
                })
            })
            
        })
    }

    getTypesFromMoviesWithSelectedCinema(movies, selected_cinema, selected_time, selected_genres) {
    
        // console.log("Selected Cinema", selected_cinema)
        // console.log("Selected Time", selected_time)
        // console.log("Selected Genres", selected_genres)
        let typesWithCinema = []
        if(selected_cinema) {
            // console.log("Inside cinema set")
            for(let m in movies) {
                for(let c in movies[m].cinemas) {
                    for(let s in movies[m].cinemas[c]) {

                        let exists = false
                        if(!selected_time) {
                            // console.log("Inside time not set - 646")
                            if(!selected_genre || selected_genre.length == 0) {
                                // console.log("Inside genre not set - 648")
                                //no time, no genre with cinema
                                if(movies[m].cinemas[c][s].cinema_id == selected_cinema.id) {
                                    if(typesWithCinema.length > 0) {
                                        for(let mc in typesWithCinema) {
                                            if(typesWithCinema[mc].name == movies[m].cinemas[c][s].experiences[0].name) {
                                                exists = true
                                            }
                                        }
                                    }

                                    if(!exists) {
                                        typesWithCinema.push(movies[m].cinemas[c][s].experiences[0])
                                    }
                                }
                            } else {
                                // console.log("Inside genre set - 664")
                                //no time, with cinema with genre
                                if(movies[m].cinemas[c][s].cinema_id == selected_cinema.id) {
                                    for(let g in selected_genres) {
                                        for(let mg in movies[m].genres) {
                                            if(movies[m].genres[mg].id == selected_genres[g].id) {
                                                if(typesWithCinema.length > 0) {
                                                    for(let mc in typesWithCinema) {
                                                        if(typesWithCinema[mc].name == movies[m].cinemas[c][s].experiences[0].name) {
                                                            exists = true
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }

                                    if(!exists) {
                                        typesWithCinema.push(movies[m].cinemas[c][s].experiences[0])
                                    }
                                }
                            }
                        } else {
                            // console.log("Inside time set - 687")
                            if(!selected_genre || selected_genre.length == 0) {
                                // console.log("Inside genre not set - 689")
                                if(movies[m].cinemas[c][s].cinema_id == selected_cinema.id && movies[m].cinemas[c][s].time_tag.includes(selected_time.hour+":")) {
                                    if(typesWithCinema.length > 0) {
                                        for(let mc in typesWithCinema) {
                                            if(typesWithCinema[mc].name == movies[m].cinemas[c][s].experiences[0].name) {
                                                exists = true
                                            }
                                        }
                                    }

                                    if(!exists) {
                                        typesWithCinema.push(movies[m].cinemas[c][s].experiences[0])
                                    }
                                }
                            } else {
                                // console.log("Inside genre set")
                                if(movies[m].cinemas[c][s].cinema_id == selected_cinema.id && movies[m].cinemas[c][s].time_tag.includes(selected_time.hour+":")) {
                                    for(let g in selected_genres) {
                                        for(let mg in movies[m].genres) {
                                            if(movies[m].genres[mg].id == selected_genres[g].id) {
                                                // console.log(movies[m].id, movies[m].cinemas[c][s].time_tag, selected_genres[g].name)
                                                if(typesWithCinema.length > 0) {
                                                    for(let mc in typesWithCinema) {
                                                        if(typesWithCinema[mc].name == movies[m].cinemas[c][s].experiences[0].name) {
                                                            exists = true
                                                        }
                                                    }
                                                }

                                                if(!exists) {
                                                    typesWithCinema.push(movies[m].cinemas[c][s].experiences[0])
                                                }
                                            }
                                        }
                                    }
                                        
                                }
                            }
                        }
                    }
                }
            }
        } else {
            // console.log("Inside cinema not set - 732")
            for(let m in movies) {
                for(let c in movies[m].cinemas) {
                    for(let s in movies[m].cinemas[c]) {

                        let exists = false
                        if(selected_time) {
                            // console.log("Inside time set - 739")
                            if(!selected_genres || selected_genres.length == 0) {
                                // console.log("Inside genres not set - 741")
                                //no cinema, no genre with time
                                // console.log("filters", selected_time.hour)
                                if(movies[m].cinemas[c][s].time_tag.includes(selected_time.hour+":")) {
                                    if(typesWithCinema.length > 0) {
                                        for(let mc in typesWithCinema) {
                                            if(typesWithCinema[mc].name == movies[m].cinemas[c][s].experiences[0].name) {
                                                exists = true
                                            }
                                        }
                                    }

                                    if(!exists) {
                                        typesWithCinema.push(movies[m].cinemas[c][s].experiences[0])
                                    }
                                }
                            } else {
                                // console.log("Inside genres set - 757")
                                //no cinema with time and genre
                                if(movies[m].cinemas[c][s].time_tag.includes(selected_time.hour+":")) {
                                    for(let g in selected_genres) {
                                        for(let mg in movies[m].genres) {
                                            if(movies[m].genres[mg].id == selected_genres[g].id) {
                                                // console.log(movies[m].id, movies[m].cinemas[c][s].time_tag, selected_genres[g].name)
                                                if(typesWithCinema.length > 0) {
                                                    for(let mc in typesWithCinema) {
                                                        if(typesWithCinema[mc].name == movies[m].cinemas[c][s].experiences[0].name) {
                                                            exists = true
                                                        }
                                                    }
                                                }

                                                if(!exists) {
                                                    typesWithCinema.push(movies[m].cinemas[c][s].experiences[0])
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        } else {
                            // console.log("Inside time not set - 781")
                            if(!selected_genres || selected_genres.length == 0) {
                                // console.log("Inside genres not set - 783")
                                //no cinema, no time, no genre
                                if(typesWithCinema.length > 0) {
                                    for(let mc in typesWithCinema) {
                                        if(typesWithCinema[mc].name == movies[m].cinemas[c][s].experiences[0].name) {
                                            exists = true
                                        }
                                    }
                                }

                                if(!exists) {
                                    typesWithCinema.push(movies[m].cinemas[c][s].experiences[0])
                                }

                            } else {
                                // console.log("Inside genres set - 798")
                                //no cinema, no time with genre
                                for(let g in selected_genres) {
                                    for(let mg in movies[m].genres) {
                                        if(movies[m].genres[mg].id == selected_genres[g].id) {
                                            // console.log(movies[m].id, movies[m].cinemas[c][s].time_tag, selected_genres[g].name)
                                            if(typesWithCinema.length > 0) {
                                                for(let mc in typesWithCinema) {
                                                    if(typesWithCinema[mc].name == movies[m].cinemas[c][s].experiences[0].name) {
                                                        exists = true
                                                    }
                                                }
                                            }

                                            if(!exists) {
                                                typesWithCinema.push(movies[m].cinemas[c][s].experiences[0])
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        // console.log("types with filters", typesWithCinema)
        return typesWithCinema
    }

    getTypesFromMoviesWithSelectedTime(movies, types, selected_time) {
        if(!selected_time) {
            return types
        }

        // console.log(movies, selected_time)
        let typesWithCinema = []
        for(let m in movies) {
            // console.log(movies[m]);
            for(let c in movies[m].cinemas) {
                for(let s in movies[m].cinemas[c]) {

                    let exists = false
                    if(movies[m].cinemas[c][s].time_tag.includes(selected_time.hour+":")) {
                        if(typesWithCinema.length > 0) {
                            for(let mc in typesWithCinema) {
                                if(typesWithCinema[mc].name == movies[m].cinemas[c][s].experiences[0].name) {
                                    exists = true
                                }
                            }
                        }

                        if(!exists) {
                            // console.log(movies[m].cinemas[c][s].time_tag, selected_time.hour, movies[m].cinemas[c][s].time_tag.includes(selected_time.hour+":"), movies[m].cinemas[c][s].experiences[0].name, movies[m].cinemas[c][s].cinema_id, movies[m].id)
                            typesWithCinema.push(movies[m].cinemas[c][s].experiences[0])
                        }
                    }
                }
            }
        }

        return typesWithCinema
    }

    getTypesWithSelectedTime(movies, types, selected_time) {
        if(!selected_time) {
            return types
        }

        return Promise.resolve(this.getTypesFromMoviesWithSelectedTime(movies, types, selected_time)).then((types_with_time) => {
            let time_cinema_types = []
            if(types.length > 0) {
                for(let t in types) {
                    // console.log(types[t])
                    for(let tt in types_with_time) {
                        let exists = []
                        if(types[t].name == types_with_time[tt].name) {
                            let exists = false
                            if(time_cinema_types.length > 0) {
                                for(let tc in time_cinema_types) {
                                    if(time_cinema_types[tc].name == types[t].name) {
                                        exists = true
                                    }
                                }
                            }

                            if(!exists) {
                                time_cinema_types.push(types[t])
                            }
                        }
                    }
                }

                return time_cinema_types
            } else {
                return types_with_time
            }
            
        });
    }

    getTypesFromMoviesWithSelectedGenres(movies, types, selected_genres) {
        if(!selected_genres || selected_genres.length == 0) {
            return types
        }

        let types_with_genres = []
        for(let m in movies) {
            for(let g in movies[m].genres) {
                for(let sg in selected_genres) {
                    if(movies[m].genres[g].name == selected_genres[sg].name) {

                        for(let c in movies[m].cinemas) {
                            for(let s in movies[m].cinemas[c]) {
                                for(let e in movies[m].cinemas[c][s].experiences) {
                                    let exists = false
                                    if(types_with_genres.length > 0) {
                                        for(let tg in types_with_genres) {
                                            if(types_with_genres[tg].name == movies[m].cinemas[c][s].experiences[e].name) {
                                                exists = true
                                            }
                                        }
                                    }

                                    if(!exists) {
                                        types_with_genres.push(movies[m].cinemas[c][s].experiences[e])
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        return types_with_genres
    }

    getTypesWithSelectedGenre(movies, types, selected_genres) {
        if(!selected_genres || selected_genres.length == 0) {
            return types
        }

        return Promise.resolve(this.getTypesFromMoviesWithSelectedGenres(movies, types, selected_genres)).then((types_with_genres) => {
            // console.log(types_with_genres)

            let genre_types = []
            if(types.length > 0) {
                for(let twg in types_with_genres) {
                    for(let t in types) {
                        let exists = false
                        if(types[t].name == types_with_genres[twg].name) {
                            if(genre_types.length > 0) {
                                for(let gt in genre_types) {
                                    if(genre_types[gt].name == types_with_genres[twg].name) {
                                        exists = true
                                    }
                                }
                            }

                            if(!exists) {
                                genre_types.push(types_with_genres[twg]);
                            }
                        }
                    }
                }

                return genre_types
            } else {
                return types_with_genres
            }
        })

    }

    getGenresFromMoviesWithFilters(movies, selected_cinema, selected_time, selected_types) {

    }

    getCinemaTypesFromMoviesFromSelectedCinema(movies, selected_cinema) {
        let filteredCinemaTypes = []
        let filteredMovies = []
        for(let m in movies) {
            for(let c in movies[m].cinemas) {
                for(let s in movies[m].cinemas[c]) {
                    for(let e in movies[m].cinemas[c][s].experiences) {
                        if(selected_cinema.id == movies[m].cinemas[c][s].cinema_id) {
                            let type_exists = false
                            let movie_exists = false
                            if(filteredCinemaTypes.length > 0) {
                                for(let fc in filteredCinemaTypes) {
                                    if(filteredCinemaTypes[fc].name == movies[m].cinemas[c][s].experiences[e].name) {
                                        type_exists = true
                                    }
                                }
                            }

                            if(filteredMovies.length > 0) {
                                for(let fm in filteredMovies) {
                                    if(filteredMovies[fm].id == movies[m].id) {
                                        movie_exists = true
                                    }
                                }
                            }

                            if(!type_exists) {
                                filteredCinemaTypes.push(movies[m].cinemas[c][s].experiences[e])
                            }

                            if(!movie_exists) {
                                filteredMovies.push(movies[m])
                            }
                        }
                    }
                }
            }
        }

        return {movies: filteredMovies, types: filteredCinemaTypes}
    }

    getCinemaTypesFromMoviesFromSelectedCinemaAndTime(movies, selected_cinema, selected_time) {
        let filteredCinemaTypes = []
        let filteredMovies = []
        for(let m in movies) {
            for(let c in movies[m].cinemas) {
                for(let s in movies[m].cinemas[c]) {
                    for(let e in movies[m].cinemas[c][s].experiences) {
                        for(let st in selected_time.ranges) {
                        // console.log(movies[m].cinemas[c][s].time_tag, selected_time.hour)
                            if(movies[m].cinemas[c][s].time_tag != undefined && movies[m].cinemas[c][s].time_tag != null) {
                                if(selected_cinema.id == movies[m].cinemas[c][s].cinema_id && movies[m].cinemas[c][s].time_tag.includes(selected_time.ranges[st].hour+":")) {
                                    // console.log(movies[m].cinemas[c][s].time_tag, selected_time.hour, movies[m].cinemas[c][s].experiences[e].name, movies[m].cinemas[c][s].cinema_id, movies[m].title)
                                    let type_exists = false
                                    let movie_exists = false
                                    if(filteredCinemaTypes.length > 0) {
                                        for(let fc in filteredCinemaTypes) {
                                            if(filteredCinemaTypes[fc].name == movies[m].cinemas[c][s].experiences[e].name) {
                                                type_exists = true
                                            }
                                        }
                                    }

                                    if(filteredMovies.length > 0) {
                                        for(let fm in filteredMovies) {
                                            if(filteredMovies[fm].id == movies[m].id) {
                                                movie_exists = true
                                            }
                                        }
                                    }

                                    if(!type_exists) {
                                        filteredCinemaTypes.push(movies[m].cinemas[c][s].experiences[e])
                                    }

                                    if(!movie_exists) {
                                        filteredMovies.push(movies[m])
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        return {movies: filteredMovies, types: filteredCinemaTypes}
    }

    getCinemaTypesFromMoviesFromSelectedCinemaAndTimeAndGenres(movies, selected_cinema, selected_time, selected_genres) {
        // console.log("hit getCinemaTypesFromMoviesFromSelectedCinemaAndTimeAndGenres")
        let filteredCinemaTypes = []
        let filteredMovies = []

        for(let m in movies) {
            for(let c in movies[m].cinemas) {
                for(let s in movies[m].cinemas[c]) {
                    for(let e in movies[m].cinemas[c][s].experiences) {
                        for(let st in selected_time.ranges) {
                            if(movies[m].cinemas[c][s].time_tag != undefined && movies[m].cinemas[c][s].time_tag != null) {
                                if(selected_cinema.id == movies[m].cinemas[c][s].cinema_id && movies[m].cinemas[c][s].time_tag.includes(selected_time.ranges[st].hour+":")) {
                                    for(let g in movies[m].genres) {
                                        for(let sg in selected_genres) {
                                            if(movies[m].genres[g].id == selected_genres[sg].id) {
                                                let type_exists = false
                                                let movie_exists = false
                                                if(filteredCinemaTypes.length > 0) {
                                                    for(let fc in filteredCinemaTypes) {
                                                        if(filteredCinemaTypes[fc].name == movies[m].cinemas[c][s].experiences[e].name) {
                                                            type_exists = true
                                                        }
                                                    }
                                                }

                                                if(filteredMovies.length > 0) {
                                                    for(let fm in filteredMovies) {
                                                        if(filteredMovies[fm].id == movies[m].id) {
                                                            movie_exists = true
                                                        }
                                                    }
                                                }

                                                if(!type_exists) {
                                                    filteredCinemaTypes.push(movies[m].cinemas[c][s].experiences[e])
                                                }

                                                if(!movie_exists) {
                                                    filteredMovies.push(movies[m])
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        return {movies: filteredMovies, types: filteredCinemaTypes}
    }

    getCinemaTypesFromMoviesFromSelectedCinemaAndGenres(movies, selected_genres, selected_cinema) {
        // console.log("hit getCinemaTypesFromMoviesFromSelectedCinemaAndGenres")
        let filteredCinemaTypes = []
        let filteredMovies = []
        for(let m in movies) {
            for(let c in movies[m].cinemas) {
                for(let s in movies[m].cinemas[c]) {
                    for(let e in movies[m].cinemas[c][s].experiences) {
                        // console.log(movies[m].cinemas[c][s].time_tag, selected_time.hour)
                        if(selected_cinema.id == movies[m].cinemas[c][s].cinema_id) {
                            for(let g in movies[m].genres) {
                                for(let sg in selected_genres) {
                                    if(movies[m].genres[g].id == selected_genres[sg].id) {
                                        let type_exists = false
                                        let movie_exists = false
                                        if(filteredCinemaTypes.length > 0) {
                                            for(let fc in filteredCinemaTypes) {
                                                if(filteredCinemaTypes[fc].name == movies[m].cinemas[c][s].experiences[e].name) {
                                                    type_exists = true
                                                }
                                            }
                                        }

                                        if(filteredMovies.length > 0) {
                                            for(let fm in filteredMovies) {
                                                if(filteredMovies[fm].id == movies[m].id) {
                                                    movie_exists = true
                                                }
                                            }
                                        }

                                        if(!type_exists) {
                                            filteredCinemaTypes.push(movies[m].cinemas[c][s].experiences[e])
                                        }

                                        if(!movie_exists) {
                                            filteredMovies.push(movies[m])
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        return {movies: filteredMovies, types: filteredCinemaTypes}
    }

    getCinemaTypesFromMoviesFromSelectedTime(movies, selected_time) {
        // console.log("hit getCinemaTypesFromMoviesFromSelectedTime")
        let filteredCinemaTypes = []
        let filteredMovies = []
        for(let m in movies) {
            for(let c in movies[m].cinemas) {
                for(let s in movies[m].cinemas[c]) {
                    for(let e in movies[m].cinemas[c][s].experiences) {
                        for(let st in selected_time.ranges) {
                            if(movies[m].cinemas[c][s].time_tag != undefined && movies[m].cinemas[c][s].time_tag != null) {
                                if(movies[m].cinemas[c][s].time_tag.includes(selected_time.ranges[st].hour+":")) {
                                    // console.log(movies[m].cinemas[c][s].time_tag, movies[m].cinemas[c][s].experiences[e].name, movies[m].cinemas[c][s].cinema_id)
                                    let type_exists = false
                                    let movie_exists = false
                                    if(filteredCinemaTypes.length > 0) {
                                        for(let fc in filteredCinemaTypes) {
                                            if(filteredCinemaTypes[fc].name == movies[m].cinemas[c][s].experiences[e].name) {
                                                type_exists = true
                                            }
                                        }
                                    }

                                    if(filteredMovies.length > 0) {
                                        for(let fm in filteredMovies) {
                                            if(filteredMovies[fm].id == movies[m].id) {
                                                movie_exists = true
                                            }
                                        }
                                    }

                                    if(!type_exists) {
                                        filteredCinemaTypes.push(movies[m].cinemas[c][s].experiences[e])
                                    }

                                    if(!movie_exists) {
                                        filteredMovies.push(movies[m])
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        return {movies: filteredMovies, types: filteredCinemaTypes}
    }

    getCinemaTypesFromMoviesFromSelectedTimeAndGenres(movies, selected_time, selected_genres) {
        let filteredCinemaTypes = []
        let filteredMovies = []
        for(let m in movies) {
            for(let c in movies[m].cinemas) {
                for(let s in movies[m].cinemas[c]) {
                    for(let e in movies[m].cinemas[c][s].experiences) {
                        // console.log(movies[m].cinemas[c][s].time_tag, selected_time.hour)
                        for(let st in selected_time.ranges) {
                            if(movies[m].cinemas[c][s].time_tag != undefined && movies[m].cinemas[c][s].time_tag != null) {
                                if(movies[m].cinemas[c][s].time_tag.includes(selected_time.ranges[st].hour+":")) {
                                    for(let g in movies[m].genres) {
                                        for(let sg in selected_genres) {
                                            if(movies[m].genres[g].id == selected_genres[sg].id) {
                                                let type_exists = false
                                                let movie_exists = false
                                                if(filteredCinemaTypes.length > 0) {
                                                    for(let fc in filteredCinemaTypes) {
                                                        if(filteredCinemaTypes[fc].name == movies[m].cinemas[c][s].experiences[e].name) {
                                                            type_exists = true
                                                        }
                                                    }
                                                }

                                                if(filteredMovies.length > 0) {
                                                    for(let fm in filteredMovies) {
                                                        if(filteredMovies[fm].id == movies[m].id) {
                                                            movie_exists = true
                                                        }
                                                    }
                                                }

                                                if(!type_exists) {
                                                    filteredCinemaTypes.push(movies[m].cinemas[c][s].experiences[e])
                                                }

                                                if(!movie_exists) {
                                                    filteredMovies.push(movies[m])
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        return {movies: filteredMovies, types: filteredCinemaTypes}
    }

    getCinemaTypesFromMoviesFromSelectedGenres(movies, selected_genres) {
        let filteredCinemaTypes = []
        let filteredMovies = []
        for(let m in movies) {
            for(let c in movies[m].cinemas) {
                for(let s in movies[m].cinemas[c]) {
                    for(let e in movies[m].cinemas[c][s].experiences) {

                        for(let g in movies[m].genres) {
                            for(let sg in selected_genres) {
                                if(movies[m].genres[g].id == selected_genres[sg].id) {
                                    let type_exists = false
                                    let movie_exists = false
                                    if(filteredCinemaTypes.length > 0) {
                                        for(let fc in filteredCinemaTypes) {
                                            if(filteredCinemaTypes[fc].name == movies[m].cinemas[c][s].experiences[e].name) {
                                                type_exists = true
                                            }
                                        }
                                    }

                                    if(filteredMovies.length > 0) {
                                        for(let fm in filteredMovies) {
                                            if(filteredMovies[fm].id == movies[m].id) {
                                                movie_exists = true
                                            }
                                        }
                                    }

                                    if(!type_exists) {
                                        filteredCinemaTypes.push(movies[m].cinemas[c][s].experiences[e])
                                    }

                                    if(!movie_exists) {
                                        filteredMovies.push(movies[m])
                                    }
                                }
                            }
                        }

                    }
                }
            }
        }

        return {movies: filteredMovies, types: filteredCinemaTypes}
    }

    getCinemaTypesFromFilters(movies, selected_cinema, selected_genres, selected_time) {

        // console.log("getCinemaTypesFromFilters")
        // console.log("movies", movies)
        // console.log("selected_cinema", selected_cinema)
        // console.log("selected_genres", selected_genres)
        // console.log("selected_time", selected_time)

        // console.log("hit getCinemaTypesFromFilters", selected_time, selected_cinema, selected_genres)

        switch(true) {
            case (selected_cinema && selected_time && (selected_genres != null  && selected_genres.length > 0)):
                // console.log("SET: cinema, time, genres")
                // console.log("enter getCinemaTypesFromMoviesFromSelectedCinemaAndTimeAndGenres")
                return Promise.resolve(this.getCinemaTypesFromMoviesFromSelectedCinemaAndTimeAndGenres(movies, selected_cinema, selected_time, selected_genres)).then((data) => {
                    return data
                })
            break;
            case (selected_cinema && selected_time && (selected_genres == null || selected_genres.length == 0)):
                // console.log("SET: cinema, time")
                // console.log("NOT SET genres")
                // console.log("enter getCinemaTypesFromMoviesFromSelectedCinemaAndTimeAndGenres")
                return Promise.resolve(this.getCinemaTypesFromMoviesFromSelectedCinemaAndTime(movies, selected_cinema, selected_time)).then((data) => {
                    return data
                })
            break;
            case (selected_cinema && !selected_time && (selected_genres != null  && selected_genres.length > 0)):
                // console.log("SET: cinema, genre")
                // console.log("NOT SET time")
                // console.log("enter getCinemaTypesFromMoviesFromSelectedCinemaAndTimeAndGenres")
                return Promise.resolve(this.getCinemaTypesFromMoviesFromSelectedCinemaAndGenres(movies, selected_genres, selected_cinema)).then((data) => {
                    return data
                })
            break;
            case (selected_cinema && !selected_time && (selected_genres == null || selected_genres.length == 0)):
                // console.log("SET: cinema")
                // console.log("NOT SET: time, genres")
                // console.log("enter getCinemaTypesFromMoviesFromSelectedCinemaAndTimeAndGenres")
                return Promise.resolve(this.getCinemaTypesFromMoviesFromSelectedCinema(movies, selected_cinema)).then((data) => {
                    return data
                })

            break;
            case (!selected_cinema && selected_time && (selected_genres == null || selected_genres.length == 0)):
                // console.log("enter getCinemaTypesFromMoviesFromSelectedCinemaAndTimeAndGenres")
                return Promise.resolve(this.getCinemaTypesFromMoviesFromSelectedTime(movies, selected_time)).then((data) => {
                    return data
                })
                // console.log("SET: time")
                // console.log("NOT SET cinema, genres")
            break;
            case (!selected_cinema && selected_time && (selected_genres != null  && selected_genres.length > 0)):
                // console.log("enter getCinemaTypesFromMoviesFromSelectedCinemaAndTimeAndGenres")
                return Promise.resolve(this.getCinemaTypesFromMoviesFromSelectedTimeAndGenres(movies, selected_time, selected_genres)).then((data) => {
                    return data
                })
                // console.log("SET: time, genres")
                // console.log("NOT SET cinema")
            break;
            case (!selected_cinema && !selected_time && (selected_genres != null  && selected_genres.length > 0)):
                // console.log("enter getCinemaTypesFromMoviesFromSelectedCinemaAndTimeAndGenres")
                return Promise.resolve(this.getCinemaTypesFromMoviesFromSelectedGenres(movies, selected_genres)).then((data) => {
                    return data
                })
                // console.log("SET: genres")
                // console.log("NOT SET cinema, time")
            break;
            case (!selected_cinema && !selected_time && (selected_genres == null || selected_genres.length == 0)):
            // console.log("enter default nothing selected")
                // console.log("NOT SET: cinema, time, genres")
                return {movies: movies, types: []}
            break;
            // default:
                // console.log("default")
            // break;
        }
    }

    separateDuplicateCinemaTypes(fitlered_types, all_types) {

        let otherTypes = []
        if(fitlered_types.length > 0) {

            for(let at in all_types) {
                let in_filtered_types = false
                for(let ft in fitlered_types) {
                    if(all_types[at].name == fitlered_types[ft].name) {
                        in_filtered_types = true
                    }
                }

                let exists = false
                if(otherTypes.length > 0) {
                    for(let ot in otherTypes) {
                        if(otherTypes[ot].name == all_types[at].name) {
                            exists = true
                        }
                    }
                }

                if(!exists && !in_filtered_types) {
                    otherTypes.push(all_types[at])
                }
            }

            return {filtered: fitlered_types, other: otherTypes}
        }

        return {filtered : [], other: all_types}
    }

    getGenresFromMoviesFromSelectedCinemaAndTimeAndTypes(movies, selected_cinema, selected_time, selected_types) {
        let filteredGenres = []
        let filteredMovies = []

        for(let m in movies) {
            for(let g in movies[m].genres) {
                for(let c in movies[m].cinemas) {
                    for(let s in movies[m].cinemas[c]) {
                        if(movies[m].cinemas[c][s].cinema_id == selected_cinema.id && movies[m].cinemas[c][s].time_tag.includes(selected_time.hour+":")) {
                            for(let t in selected_types) {
                                for(let e in movies[m].cinemas[c][s].experiences) {
                                    if(selected_types[t].name == movies[m].cinemas[c][s].experiences[e].name) {
                                        let genre_exists = false
                                        let movie_exists = false

                                        if(filteredGenres.length > 0) {
                                            for(let fg in filteredGenres) {
                                                if(filteredGenres[fg].id == movies[m].genres[g].id) {
                                                    genre_exists = true
                                                }
                                            }
                                        }

                                        if(filteredMovies.length > 0) {
                                            for(let fm in filteredMovies) {
                                                if(filteredMovies[fm].id == movies[m].id) {
                                                    movie_exists = true
                                                }
                                            }
                                        }

                                        if(!genre_exists) {
                                            filteredGenres.push(movies[m].genres[g])
                                        }

                                        if(!movie_exists) {
                                            filteredMovies.push(movies[m])
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        return {genres: filteredGenres, movies: filteredMovies}
    }

    getGenresFromMoviesFromSelectedCinemaAndTime(movies, selected_cinema, selected_time) {
        let filteredGenres = []
        let filteredMovies = []

        for(let m in movies) {
            for(let g in movies[m].genres) {
                for(let c in movies[m].cinemas) {
                    for(let s in movies[m].cinemas[c]) {
                        if(movies[m].cinemas[c][s].cinema_id == selected_cinema.id && movies[m].cinemas[c][s].time_tag.includes(selected_time.hour+":")) {
                            let genre_exists = false
                            let movie_exists = false

                            if(filteredGenres.length > 0) {
                                for(let fg in filteredGenres) {
                                    if(filteredGenres[fg].id == movies[m].genres[g].id) {
                                        genre_exists = true
                                    }
                                }
                            }

                            if(filteredMovies.length > 0) {
                                for(let fm in filteredMovies) {
                                    if(filteredMovies[fm].id == movies[m].id) {
                                        movie_exists = true
                                    }
                                }
                            }

                            if(!genre_exists) {
                                filteredGenres.push(movies[m].genres[g])
                            }

                            if(!movie_exists) {
                                filteredMovies.push(movies[m])
                            }
                        }
                    }
                }
            }
        }

        return {genres: filteredGenres, movies: filteredMovies}
    }

    getGenresFromMoviesFromSelectedCinemaAndTypes(movies, selected_types, selected_cinema) {
        let filteredGenres = []
        let filteredMovies = []

        for(let m in movies) {
            for(let g in movies[m].genres) {
                for(let c in movies[m].cinemas) {
                    for(let s in movies[m].cinemas[c]) {
                        if(movies[m].cinemas[c][s].cinema_id == selected_cinema.id) {
                            for(let t in selected_types) {
                                for(let e in movies[m].cinemas[c][s].experiences) {
                                    if(selected_types[t].name == movies[m].cinemas[c][s].experiences[e].name) {
                                        let genre_exists = false
                                        let movie_exists = false

                                        if(filteredGenres.length > 0) {
                                            for(let fg in filteredGenres) {
                                                if(filteredGenres[fg].id == movies[m].genres[g].id) {
                                                    genre_exists = true
                                                }
                                            }
                                        }

                                        if(filteredMovies.length > 0) {
                                            for(let fm in filteredMovies) {
                                                if(filteredMovies[fm].id == movies[m].id) {
                                                    movie_exists = true
                                                }
                                            }
                                        }

                                        if(!genre_exists) {
                                            filteredGenres.push(movies[m].genres[g])
                                        }

                                        if(!movie_exists) {
                                            filteredMovies.push(movies[m])
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        return {genres: filteredGenres, movies: filteredMovies}
    }

    getGenresFromMoviesFromSelectedCinema(movies, selected_cinema) {
        let filteredGenres = []
        let filteredMovies = []

        for(let m in movies) {
            for(let g in movies[m].genres) {
                for(let c in movies[m].cinemas) {
                    for(let s in movies[m].cinemas[c]) {
                        if(movies[m].cinemas[c][s].cinema_id) {
                            let genre_exists = false
                            let movie_exists = false

                            if(filteredGenres.length > 0) {
                                for(let fg in filteredGenres) {
                                    if(filteredGenres[fg].id == movies[m].genres[g].id) {
                                        genre_exists = true
                                    }
                                }
                            }

                            if(filteredMovies.length > 0) {
                                for(let fm in filteredMovies) {
                                    if(filteredMovies[fm].id == movies[m].id) {
                                        movie_exists = true
                                    }
                                }
                            }

                            if(!genre_exists) {
                                filteredGenres.push(movies[m].genres[g])
                            }

                            if(!movie_exists) {
                                filteredMovies.push(movies[m])
                            }
                        }
                    }
                }
            }
        }

        return {genres: filteredGenres, movies: filteredMovies}
    }

    getGenresFromMoviesFromSelectedTime(movies, selected_time) {
        let filteredGenres = []
        let filteredMovies = []

        for(let m in movies) {
            for(let g in movies[m].genres) {
                for(let c in movies[m].cinemas) {
                    for(let s in movies[m].cinemas[c]) {
                        if(movies[m].cinemas[c][s].time_tag.includes(selected_time.hour+":")) {
                            let genre_exists = false
                            let movie_exists = false

                            if(filteredGenres.length > 0) {
                                for(let fg in filteredGenres) {
                                    if(filteredGenres[fg].id == movies[m].genres[g].id) {
                                        genre_exists = true
                                    }
                                }
                            }

                            if(filteredMovies.length > 0) {
                                for(let fm in filteredMovies) {
                                    if(filteredMovies[fm].id == movies[m].id) {
                                        movie_exists = true
                                    }
                                }
                            }

                            if(!genre_exists) {
                                filteredGenres.push(movies[m].genres[g])
                            }

                            if(!movie_exists) {
                                filteredMovies.push(movies[m])
                            }
                        }
                    }
                }
            }
        }

        return {genres: filteredGenres, movies: filteredMovies}
    }

    getGenresFromMoviesFromSelectedTimeAndTypes(movies, selected_time, selected_types) {
        let filteredGenres = []
        let filteredMovies = []

        for(let m in movies) {
            for(let g in movies[m].genres) {
                for(let c in movies[m].cinemas) {
                    for(let s in movies[m].cinemas[c]) {
                        if(movies[m].cinemas[c][s].time_tag.includes(selected_time.hour+":")) {
                            for(let t in selected_types) {
                                for(let e in movies[m].cinemas[c][s].experiences) {
                                    if(selected_types[t].name == movies[m].cinemas[c][s].experiences[e].name) {
                                        let genre_exists = false
                                        let movie_exists = false

                                        if(filteredGenres.length > 0) {
                                            for(let fg in filteredGenres) {
                                                if(filteredGenres[fg].id == movies[m].genres[g].id) {
                                                    genre_exists = true
                                                }
                                            }
                                        }

                                        if(filteredMovies.length > 0) {
                                            for(let fm in filteredMovies) {
                                                if(filteredMovies[fm].id == movies[m].id) {
                                                    movie_exists = true
                                                }
                                            }
                                        }

                                        if(!genre_exists) {
                                            filteredGenres.push(movies[m].genres[g])
                                        }

                                        if(!movie_exists) {
                                            filteredMovies.push(movies[m])
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        return {genres: filteredGenres, movies: filteredMovies}
    }

    getGenresFromMoviesFromSelectedTypes(movies, selected_types) {
        let filteredGenres = []
        let filteredMovies = []

        for(let m in movies) {
            for(let g in movies[m].genres) {
                for(let c in movies[m].cinemas) {
                    for(let s in movies[m].cinemas[c]) {
                        for(let t in selected_types) {
                            for(let e in movies[m].cinemas[c][s].experiences) {
                                if(selected_types[t].name == movies[m].cinemas[c][s].experiences[e].name) {
                                    let genre_exists = false
                                    let movie_exists = false

                                    if(filteredGenres.length > 0) {
                                        for(let fg in filteredGenres) {
                                            if(filteredGenres[fg].id == movies[m].genres[g].id) {
                                                genre_exists = true
                                            }
                                        }
                                    }

                                    if(filteredMovies.length > 0) {
                                        for(let fm in filteredMovies) {
                                            if(filteredMovies[fm].id == movies[m].id) {
                                                movie_exists = true
                                            }
                                        }
                                    }

                                    if(!genre_exists) {
                                        filteredGenres.push(movies[m].genres[g])
                                    }

                                    if(!movie_exists) {
                                        filteredMovies.push(movies[m])
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        return {genres: filteredGenres, movies: filteredMovies}
    }

    getGenresFromFilters(movies, selected_cinema, selected_types, selected_time) {

        // console.log("movies", movies)

        // console.log("hit getGenresFromFilters")

        let filteredMoviesByCinema = []
        if(selected_cinema && selected_cinema.id > 0) {
            for(let m in movies) {
                for(let c in movies[m].cinemas) {
                    for(let s in movies[m].cinemas[c]) {
                        // console.log(movies[m].cinemas[c][s], movies[m].cinemas[c][s].cinema_id)
                        if(movies[m].cinemas[c][s].cinema_id == selected_cinema.id) {
                            let exists = false

                            if(filteredMoviesByCinema.length > 0) {
                                for(let fmc in filteredMoviesByCinema) {
                                    if(filteredMoviesByCinema[fmc].id == movies[m].id) {
                                        exists = true
                                    }
                                }
                            }

                            if(!exists) {
                                filteredMoviesByCinema.push(movies[m])
                            }
                        }
                    }
                }
            }

            // console.log("filteredMoviesByCinema", filteredMoviesByCinema)
            movies = filteredMoviesByCinema
        }

        let filteredMoviesByTypes = []
        if(selected_types && selected_types.length > 0) {
            for(let m in movies) {
                for(let c in movies[m].cinemas) {
                    for(let s in movies[m].cinemas[c]) {
                        for(let e in movies[m].cinemas[c][s].experiences) {
                            for(let tg in selected_types) {
                                for(let t in selected_types[tg].types) {
                                    let exists = false
                                    if(selected_types[tg].types[t].name == movies[m].cinemas[c][s].experiences[e].name) {
                                        if(filteredMoviesByTypes.length > 0) {
                                            for(let fm in filteredMoviesByTypes) {
                                                if(filteredMoviesByTypes[fm].id == movies[m].id) {
                                                    exists = true
                                                }
                                            }
                                        }

                                        if(!exists) {
                                            filteredMoviesByTypes.push(movies[m])
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            // console.log("filteredMoviesByTypes", filteredMoviesByTypes)
            movies = filteredMoviesByTypes
        }

        let filteredMoviesByTimes = []
        if(selected_time) {
            for(let m in movies) {
                for(let c in movies[m].cinemas) {
                    for(let s in movies[m].cinemas[c]) {
                        for(let st in selected_time.ranges) {
                            if(movies[m].cinemas[c][s].time_tag != undefined && movies[m].cinemas[c][s].time_tag != null) {
                                if(movies[m].cinemas[c][s].time_tag.includes(selected_time.ranges[st].hour+":")) {
                                    let exists = false
                                    if(filteredMoviesByTimes.length > 0) {
                                        for(let fmt in filteredMoviesByTimes) {
                                            if(filteredMoviesByTimes[fmt].id == movies[m].id) {
                                                exists = true
                                            }
                                        }
                                    }

                                    if(!exists) {
                                        filteredMoviesByTimes.push(movies[m])
                                    }
                                }
                            }       
                        }
                    }
                }
            }
            // console.log("filteredMoviesByTimes", filteredMoviesByTimes)
            movies = filteredMoviesByTimes
        }

        let genres = []
        for(let m in movies) {
            for(let g in movies[m].genres) {
                let exists = false
                if(genres.length > 0) {
                    for(let gg in genres) {
                        if(genres[gg].id == movies[m].genres[g].id) {
                            exists = true
                        }
                    }
                }

                if(!exists) {
                    genres.push(movies[m].genres[g])
                }
            }
        }

        // console.log("exit getGenresFromFilters")

        return genres

    }

    separateDuplicateGenres(filtered_genres, all_genres) {
        let otherGenres = []
        if(filtered_genres.length > 0) {

            for(let at in all_genres) {
                let in_filtered_genres = false
                for(let ft in filtered_genres) {
                    if(all_genres[at].id == filtered_genres[ft].id) {
                        in_filtered_genres = true
                    }
                }

                let exists = false
                if(otherGenres.length > 0) {
                    for(let ot in otherGenres) {
                        if(otherGenres[ot].id == all_genres[at].id) {
                            exists = true
                        }
                    }
                }

                if(!exists && !in_filtered_genres) {
                    otherGenres.push(all_genres[at])
                }
            }

            return {filtered: filtered_genres, other: otherGenres}
        }

        return {filtered : [], other: all_genres}
    }

    generateAvailableTypesAndGenres(movies, meta, selected_cinema, selected_types, selected_genres, selected_time, type_groups) {
        let cinema_selection_for_types = null
        if(selected_cinema) {
            if(selected_cinema.id > 0) {
                cinema_selection_for_types = selected_cinema
            }
        }
        return Promise.all([this.getCinemaTypesFromFilters(movies, cinema_selection_for_types, selected_genres, selected_time), this.getGenresFromFilters(movies, selected_cinema, selected_types, selected_time)]).then(([types_from_filters, genres_from_filters]) => {
            // console.log("types_from_filters",types_from_filters)
            return Promise.all([this.separateDuplicateCinemaTypes(types_from_filters.types, meta.experiences), this.separateDuplicateGenres(genres_from_filters, meta.genres)]).then(([types, genres]) => {
                // console.log("type groups in region service", type_groups)

                let typeOptions = []
                let typeOptionsFiltered = []
                let typeOptionsOther = []

                // console.log("type_groups", type_groups)
                // console.log("filtered types", types)

                for(let tg in type_groups) {
                    // console.log(type_groups[tg])
                    for(let t in type_groups[tg].types) {
                        // console.log(type_groups[tg].types[t])
                        // console.log(types.filtered)
                        for(let tf in types.filtered) {
                            // console.log()
                            // console.log(types.filtered[tf].name, "?=", type_groups[tg].types[t].name)
                            let exists = false
                            if(types.filtered[tf].name == type_groups[tg].types[t].name) {
                                if(typeOptionsFiltered.length > 0) {
                                    for(let tof in typeOptionsFiltered) {
                                        if(typeOptionsFiltered[tof].name == type_groups[tg].name) {
                                            exists = true
                                        }
                                    }
                                }

                                if(!exists) {
                                    typeOptionsFiltered.push(type_groups[tg])
                                }
                            }
                        }

                        for(let to in types.other) {
                            // console.log(types.other[to].name, "?=", type_groups[tg].types[t].name)
                            let exists = false
                            if(types.other[to].name == type_groups[tg].types[t].name) {
                                if(typeOptionsOther.length > 0) {
                                    for(let too in typeOptionsOther) {
                                        if(typeOptionsOther[too].name == type_groups[tg].name) {
                                            exists = true
                                        }
                                    }
                                }

                                if(!exists) {
                                    typeOptionsOther.push(type_groups[tg])
                                }
                            }
                        }
                    }
                }

                // console.log("type options other", typeOptionsFiltered)
                // console.log("type options other", typeOptionsOther)


                let otherTypes = []

                for(let to in typeOptionsOther) {
                    let existsInFitlered = false
                    for(let ft in typeOptionsFiltered) {
                        if(typeOptionsOther[to].name == typeOptionsFiltered[ft].name) {
                            existsInFitlered = true
                        }
                    }

                    if(!existsInFitlered) {
                        otherTypes.push(typeOptionsOther[to])
                    }
                }

                typeOptionsOther = otherTypes


                typeOptions = [{label: "Cinema types based on your filter", items: typeOptionsFiltered}, {label: "Other Cinema Types", items: typeOptionsOther}]
                let genreOptions = [{label:"Genres based on your filter", items: genres.filtered}, {label:"Other Genres", items: genres.other}]
                let combined = [{label: "Cinema types based on your filter", items: types.filtered}, {label: "Other Cinema Types", items: types.other},{label:"Genres based on your filter", items: genres.filtered}, {label:"Other Genres", items: genres.other}]

                return {types: typeOptions, genres: genreOptions, combined:combined}
            })  
        })
    }

    getCinemasFromMoviesForSelectedTimeAndTypesAndGenres(movies, selected_time, selected_types, selected_genres) {
        let filteredMovies = []
        let filteredCinemas = []

        for(let m in movies) {
            for(let c in movies[m].cinemas) {
                for(let s in movies[m].cinemas[c]) {

                    //filter time
                    if(movies[m].cinemas[c][s].time_tag.includes(selected_time.hour+":")) {

                        //filter types
                        for(let e in movies[m].cinemas[c][s].experiences) {
                            for(let st in selected_types) {
                                if(movies[m].cinemas[c][s].experiences[e].name == selected_types[st].name) {
                                    //filter genres
                                    for(let g in movies[m].genres) {
                                        for(let sg in selected_genres) {
                                            let movie_exists = false
                                            let cinema_exists = false
                                            if(selected_genres[sg].id == movies[m].genres[g].id) {
                                                if(filteredCinemas.length > 0) {
                                                    for(let fc in filteredCinemas) {
                                                        if(movies[m].cinemas[c][s].cinema != undefined) {
                                                            if(filteredCinemas[fc].id == movies[m].cinemas[c][s].cinema.id) {
                                                                cinema_exists = true
                                                            }
                                                        }
                                                    }
                                                }

                                                if(filteredMovies.length > 0) {
                                                    for(let fm in filteredMovies) {
                                                        if(filteredMovies[fm].id == movies[m].id) {
                                                            movie_exists = true
                                                        }
                                                    }
                                                }

                                                if(!cinema_exists) {
                                                filteredCinemas.push(movies[m].cinemas[c][s].cinema)
                                                }

                                                if(!movie_exists) {
                                                    filteredMovies.push(movies[m])
                                                }
                                            }                                            
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        return {cinemas: filteredCinemas, movies: filteredMovies}
    }

    getCinemasFromMoviesForSelectedTimeAndTypes(movies, selected_time, selected_types) {
        let filteredMovies = []
        let filteredCinemas = []

        for(let m in movies) {
            for(let c in movies[m].cinemas) {
                for(let s in movies[m].cinemas[c]) {

                    //filter time
                    if(movies[m].cinemas[c][s].time_tag.includes(selected_time.hour+":")) {

                        //filter types
                        for(let e in movies[m].cinemas[c][s].experiences) {
                            for(let st in selected_types) {
                                let movie_exists = false
                                let cinema_exists = false
                                if(movies[m].cinemas[c][s].experiences[e].name == selected_types[st].name) {

                                    if(filteredCinemas.length > 0) {
                                        for(let fc in filteredCinemas) {
                                            if(movies[m].cinemas[c][s].cinema != undefined) {
                                                if(filteredCinemas[fc].id == movies[m].cinemas[c][s].cinema.id) {
                                                    cinema_exists = true
                                                }
                                            }
                                        }
                                    }

                                    if(filteredMovies.length > 0) {
                                        for(let fm in filteredMovies) {
                                            if(filteredMovies[fm].id == movies[m].id) {
                                                movie_exists = true
                                            }
                                        }
                                    }

                                    if(!cinema_exists) {
                                    filteredCinemas.push(movies[m].cinemas[c][s].cinema)
                                    }

                                    if(!movie_exists) {
                                        filteredMovies.push(movies[m])
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        return {cinemas: filteredCinemas, movies: filteredMovies}
    }

    getCinemasFromMoviesForSelectedTimeAndGenres(movies, selected_time, selected_genres) {
        let filteredMovies = []
        let filteredCinemas = []

        for(let m in movies) {
            for(let c in movies[m].cinemas) {
                for(let s in movies[m].cinemas[c]) {

                    //filter time
                    if(movies[m].cinemas[c][s].time_tag.includes(selected_time.hour+":")) {

                        //filter genres
                        for(let g in movies[m].genres) {
                            for(let sg in selected_genres) {
                                let movie_exists = false
                                let cinema_exists = false
                                if(selected_genres[sg].id == movies[m].genres[g].id) {
                                    if(filteredCinemas.length > 0) {
                                        for(let fc in filteredCinemas) {
                                            if(movies[m].cinemas[c][s].cinema != undefined) {
                                                if(filteredCinemas[fc].id == movies[m].cinemas[c][s].cinema.id) {
                                                    cinema_exists = true
                                                }
                                            }
                                        }
                                    }

                                    if(filteredMovies.length > 0) {
                                        for(let fm in filteredMovies) {
                                            if(filteredMovies[fm].id == movies[m].id) {
                                                movie_exists = true
                                            }
                                        }
                                    }

                                    if(!cinema_exists) {
                                        filteredCinemas.push(movies[m].cinemas[c][s].cinema)
                                    }

                                    if(!movie_exists) {
                                        filteredMovies.push(movies[m])
                                    }
                                }                                            
                            }
                        }
                    }
                }
            }
        }

        return {cinemas: filteredCinemas, movies: filteredMovies}
    }

    getCinemasFromMoviesForSelectedTypesAndGenres(movies, selected_types, selected_genres) {
        let filteredMovies = []
        let filteredCinemas = []

        for(let m in movies) {
            for(let c in movies[m].cinemas) {
                for(let s in movies[m].cinemas[c]) {

                    //filter types
                    for(let e in movies[m].cinemas[c][s].experiences) {
                        for(let st in selected_types) {
                            if(movies[m].cinemas[c][s].experiences[e].name == selected_types[st].name) {
                                //filter genres
                                for(let g in movies[m].genres) {
                                    for(let sg in selected_genres) {
                                        let movie_exists = false
                                        let cinema_exists = false
                                        if(selected_genres[sg].id == movies[m].genres[g].id) {
                                            if(filteredCinemas.length > 0) {
                                                for(let fc in filteredCinemas) {
                                                    if(movies[m].cinemas[c][s].cinema != undefined) {
                                                        if(filteredCinemas[fc].id == movies[m].cinemas[c][s].cinema.id) {
                                                            cinema_exists = true
                                                        }
                                                    }
                                                }
                                            }

                                            if(filteredMovies.length > 0) {
                                                for(let fm in filteredMovies) {
                                                    if(filteredMovies[fm].id == movies[m].id) {
                                                        movie_exists = true
                                                    }
                                                }
                                            }

                                            if(!cinema_exists) {
                                                filteredCinemas.push(movies[m].cinemas[c][s].cinema)
                                            }

                                            if(!movie_exists) {
                                                filteredMovies.push(movies[m])
                                            }
                                        }                                            
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        return {cinemas: filteredCinemas, movies: filteredMovies}
    }

    getCinemasFromMoviesForSelectedTime(movies, selected_time) {
        let filteredMovies = []
        let filteredCinemas = []

        for(let m in movies) {
            for(let c in movies[m].cinemas) {
                for(let s in movies[m].cinemas[c]) {

                    //filter time
                    if(movies[m].cinemas[c][s].time_tag.includes(selected_time.hour+":")) {
                        let movie_exists = false
                        let cinema_exists = false

                        if(filteredCinemas.length > 0) {
                            for(let fc in filteredCinemas) {
                                if(movies[m].cinemas[c][s].cinema != undefined) {
                                    if(filteredCinemas[fc].id == movies[m].cinemas[c][s].cinema.id) {
                                        cinema_exists = true
                                    }
                                }
                            }
                        }

                        if(filteredMovies.length > 0) {
                            for(let fm in filteredMovies) {
                                if(filteredMovies[fm].id == movies[m].id) {
                                    movie_exists = true
                                }
                            }
                        }

                        if(!cinema_exists) {
                        filteredCinemas.push(movies[m].cinemas[c][s].cinema)
                        }

                        if(!movie_exists) {
                            filteredMovies.push(movies[m])
                        }
                    }
                }
            }
        }

        return {cinemas: filteredCinemas, movies: filteredMovies}
    }

    getCinemasFromMoviesForSelectedTypes(movies, selected_types) {
        let filteredMovies = []
        let filteredCinemas = []

        for(let m in movies) {
            for(let c in movies[m].cinemas) {
                for(let s in movies[m].cinemas[c]) {

                    //filter types
                    for(let e in movies[m].cinemas[c][s].experiences) {
                        for(let st in selected_types) {
                            let movie_exists = false
                            let cinema_exists = false
                            if(movies[m].cinemas[c][s].experiences[e].name == selected_types[st].name) {

                                if(filteredCinemas.length > 0) {
                                    for(let fc in filteredCinemas) {
                                        if(movies[m].cinemas[c][s].cinema != undefined) {
                                            if(filteredCinemas[fc].id == movies[m].cinemas[c][s].cinema.id) {
                                                cinema_exists = true
                                            }
                                        }
                                    }
                                }

                                if(filteredMovies.length > 0) {
                                    for(let fm in filteredMovies) {
                                        if(filteredMovies[fm].id == movies[m].id) {
                                            movie_exists = true
                                        }
                                    }
                                }

                                if(!cinema_exists) {
                                filteredCinemas.push(movies[m].cinemas[c][s].cinema)
                                }

                                if(!movie_exists) {
                                    filteredMovies.push(movies[m])
                                }
                            }
                        }
                    }
                }
            }
        }

        return {cinemas: filteredCinemas, movies: filteredMovies}
    }

    getCinemasFromMoviesForSelectedGenres(movies, selected_genres) {
        let filteredMovies = []
        let filteredCinemas = []

        for(let m in movies) {
            for(let c in movies[m].cinemas) {
                for(let s in movies[m].cinemas[c]) {

                    //filter genres
                    for(let g in movies[m].genres) {
                        for(let sg in selected_genres) {
                            let movie_exists = false
                            let cinema_exists = false
                            if(selected_genres[sg].id == movies[m].genres[g].id) {
                                if(filteredCinemas.length > 0) {
                                    for(let fc in filteredCinemas) {
                                        if(movies[m].cinemas[c][s].cinema != undefined) {
                                            if(filteredCinemas[fc].id == movies[m].cinemas[c][s].cinema.id) {
                                                cinema_exists = true
                                            }
                                        }
                                    }
                                }

                                if(filteredMovies.length > 0) {
                                    for(let fm in filteredMovies) {
                                        if(filteredMovies[fm].id == movies[m].id) {
                                            movie_exists = true
                                        }
                                    }
                                }

                                if(!cinema_exists) {
                                filteredCinemas.push(movies[m].cinemas[c][s].cinema)
                                }

                                if(!movie_exists) {
                                    filteredMovies.push(movies[m])
                                }
                            }                                            
                        }
                    }
                }
            }
        }

        return {cinemas: filteredCinemas, movies: filteredMovies}
    }

    sortCinemasAlphaAsc(cinemas) {
        if(cinemas.length > 0) {
            cinemas.sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0)); 

            return cinemas
        }
        return cinemas
    }

    getRegionsBasedOnFilterSelection(movies, selected_types, selected_genres, selected_time) {
        // console.log("hit getRegionsBasedOnFilterSelection", movies, selected_types, selected_genres, selected_time)
        let checked_types = false
        let checked_genres = false
        let checked_time = false
        let filteredMoviesByTypes = []
        if(selected_types && selected_types.length > 0) {
            // console.log("enter getRegionsBasedOnFilterSelection filterMoviesByTypes", movies, selected_types)
            for(let m in movies) {
                for(let c in movies[m].cinemas) {
                    for(let s in movies[m].cinemas[c]) {
                        for(let e in movies[m].cinemas[c][s].experiences) {
                            for(let tg in selected_types) {
                                for(let t in selected_types[tg].types) {
                                    let exists = false
                                    if(selected_types[tg].types[t].name == movies[m].cinemas[c][s].experiences[e].name) {
                                        if(filteredMoviesByTypes.length > 0) {
                                            for(let fm in filteredMoviesByTypes) {
                                                if(filteredMoviesByTypes[fm].id == movies[m].id) {
                                                    exists = true
                                                }
                                            }
                                        }

                                        if(!exists) {
                                            filteredMoviesByTypes.push(movies[m])
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }

            checked_types = true
            movies = filteredMoviesByTypes
            // console.log("exit getRegionsBasedOnFilterSelection filterMoviesByTypes", movies, checked_types)
        }

        // console.log("Movies By Types", filteredMoviesByTypes)

        let filteredMoviesByTimes = []
        if(selected_time && selected_time != null && typeof selected_time == "object") {
            // console.log("selected_time", selected_time)
            // console.log("enter getRegionsBasedOnFilterSelection filteredMoviesByTimes", movies, selected_time)
            for(let m in movies) {
                // console.log(filteredMoviesByTypes[m])
                for(let c in movies[m].cinemas) {
                    for(let s in movies[m].cinemas[c]) {
                        for(let st in selected_time.ranges) {
                            if(movies[m].cinemas[c][s].time_tag != undefined && movies[m].cinemas[c][s].time_time != null) {
                                if(movies[m].cinemas[c][s].time_tag.includes(selected_time.ranges[st].hour+":")) {
                                    let exists = false
                                    if(filteredMoviesByTimes.length > 0) {
                                        for(let fmt in filteredMoviesByTimes) {
                                            if(filteredMoviesByTimes[fmt].id == movies[m].id) {
                                                exists = true
                                            }
                                        }
                                    }

                                    if(!exists) {
                                        filteredMoviesByTimes.push(movies[m])
                                    }
                                }
                            }
                        }
                    }
                }
            }

            checked_time = true
            movies = filteredMoviesByTimes
            // console.log("exit getRegionsBasedOnFilterSelection filteredMoviesByTimes", movies, checked_time)
        }

        // console.log("Movies By Time", filteredMoviesByTimes)

        let filteredMoviesByGenres = []
        if(selected_genres && selected_genres.length > 0) {
            // console.log("enter getRegionsBasedOnFilterSelection filteredMoviesByGenres", movies, selected_genres)
            for(let m in movies) {
                for(let g in movies[m].genres) {
                    for(let sg in selected_genres) {
                        let exists = false
                        if(selected_genres[sg].id == movies[m].genres[g].id) {
                            if(filteredMoviesByGenres.length > 0) {
                                for(let fmg in filteredMoviesByGenres) {
                                    if(filteredMoviesByGenres[fmg].id == movies[m].id) {
                                        exists = true
                                    }
                                }
                            }

                            if(!exists) {
                                filteredMoviesByGenres.push(movies[m])
                            }
                        }
                    }
                }
            }
            checked_genres = true
            movies = filteredMoviesByGenres
            // console.log("exit getRegionsBasedOnFilterSelection filteredMoviesByGenres", movies, checked_genres)
        }

        let cinemas = []
        
        if(checked_types || checked_genres || checked_time) {
            // console.log("hit generate Cinemas in getRegionsBasedOnFilterSelection", movies)
            for(let m in movies) {
                for(let c in movies[m].cinemas) {
                    for(let s in movies[m].cinemas[c]) {
                        let exists = false

                        if(cinemas.length > 0) {
                            for(let ci in cinemas) {
                                // console.log("movies[m].cinemas[c][s]",movies[m].cinemas[c][s])
                                // console.log("movies[m].cinemas[c][s].cinema", movies[m].cinemas[c][s].cinema, movies[m].cinemas[c][s].cinema != undefined)
                                // console.log("cinemas[ci]", cinemas[ci])
                                // console.log("movies[m].cinemas[c][s].cinema.id",movies[m].cinemas[c][s].cinema.id)
                                // console.log("movies[m].cinemas[c][s].cinema_id", movies[m].cinemas[c][s].cinema_id)
                                if(movies[m].cinemas[c][s].cinema != undefined && (cinemas[ci] != undefined && typeof cinemas[ci] == "object")) {
                                    if(cinemas[ci].id == movies[m].cinemas[c][s].cinema.id) {
                                        exists = true
                                    }
                                }
                            }
                        }

                        if(movies[m].cinemas[c][s].cinema != undefined && movies[m].cinemas[c][s].cinema != null) {
                            if(!exists) {
                                cinemas.push(movies[m].cinemas[c][s].cinema)
                            }
                        }
                    }
                }
            }

            // console.log("end generate Cinemas in getRegionsBasedOnFilterSelection", cinemas, movies)
            return Promise.resolve(this.sortCinemasAlphaAsc(cinemas)).then((sorted_cinemas) => {
                // console.log("getRegionsBasedOnFilterSelection promise resolved", sorted_cinemas, movies)
                return {cinemas: sorted_cinemas, movies: movies}
            })
        }

        // console.log("end generate Cinemas in getRegionsBasedOnFilterSelection", cinemas, movies)
        return {cinemas: cinemas, movies: movies}
    }

    separateTimeRanges(time_tags, time_ranges) {
        let filteredTimes = []
        let otherTimes = []

        if(time_tags.length > 0) {
            for(let tr in time_ranges) {
                for(let tt in time_tags) {
                    let tag_exists = false
                    let other_exists = false
                    if(time_tags[tt].includes(time_ranges[tr].hour+":")) {
                        if(filteredTimes.length > 0) {
                            for(let ft in filteredTimes) {
                                if(filteredTimes[ft].hour == time_ranges[tr].hour) {
                                    tag_exists = true
                                }
                            }
                        }

                        if(!tag_exists) {
                            filteredTimes.push(time_ranges[tr])
                        }
                    } else {
                        let add_to_other = true
                        if(otherTimes.length > 0) {
                            for(let ot in otherTimes) {
                            
                                if(otherTimes[ot].hour == time_ranges[tr].hour) {
                                    other_exists = true
                                }
                            }
                        }

                        if(filteredTimes.length > 0) {
                            for(let ft in filteredTimes) {
                                if(filteredTimes[ft].hour == time_ranges[tr].hour) {
                                    add_to_other = false
                                }
                            }
                        }

                        if(add_to_other) {
                            if(!other_exists) {
                                otherTimes.push(time_ranges[tr])
                            }
                        }
                    }
                }
            }
        } else {
            otherTimes = time_ranges
        }

        for(let ft in filteredTimes) {
            for(let ot in otherTimes) {
                if(filteredTimes[ft].hour == otherTimes[ot].hour) {
                    otherTimes.splice(ot, 1)
                }
            }
        }

        return [{name: "Time ranges based on your filter", items: filteredTimes},{name: "Other time ranges", items: otherTimes}]
    }

    getTimesFromMoviesForSelectedCinemaAndTypesAndGenres(movies, selected_cinema, selected_types, selected_genres) {
        let filteredMovies = []
        let filteredTimes = []

        for(let m in movies) {
            for(let c in movies[m].cinemas) {
                for(let s in movies[m].cinemas[c]) {

                    //filter cinema
                    if(movies[m].cinemas[c][s].cinema.id == selected_cinema.id) {

                        //filter types
                        for(let e in movies[m].cinemas[c][s].experiences) {
                            for(let st in selected_types) {
                                if(movies[m].cinemas[c][s].experiences[e].name == selected_types[st].name) {
                                    // console.log(movies[m].cinemas[c][s].cinema.name, selected_types[st].name)
                                    //filter genres
                                    for(let g in movies[m].genres) {
                                        for(let sg in selected_genres) {
                                            let movie_exists = false
                                            let time_exists = false


                                            if(selected_genres[sg].id == movies[m].genres[g].id) {
                                                if(filteredTimes.length > 0) {
                                                    for(let fc in filteredTimes) {
                                                        if(filteredTimes[fc] == movies[m].cinemas[c][s].time_tag) {
                                                            time_exists = true
                                                        }
                                                    }
                                                }

                                                if(filteredMovies.length > 0) {
                                                    for(let fm in filteredMovies) {
                                                        if(filteredMovies[fm].id == movies[m].id) {
                                                            movie_exists = true
                                                        }
                                                    }
                                                }

                                                if(!time_exists) {
                                                    filteredTimes.push(movies[m].cinemas[c][s].time_tag)
                                                }

                                                if(!movie_exists) {
                                                    filteredMovies.push(movies[m])
                                                }
                                            }                                            
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        return {time_tags: filteredTimes, movies: movies}
    }

    getTimesFromMoviesForSelectedCinemaAndGenres(movies, selected_cinema, selected_genres) {
        let filteredMovies = []
        let filteredTimes = []

        for(let m in movies) {
            for(let c in movies[m].cinemas) {
                for(let s in movies[m].cinemas[c]) {

                    //filter cinema
                    if(movies[m].cinemas[c][s].cinema.id == selected_cinema.id) {

                        //filter genres
                        for(let g in movies[m].genres) {
                            for(let sg in selected_genres) {
                                let movie_exists = false
                                let time_exists = false


                                if(selected_genres[sg].id == movies[m].genres[g].id) {
                                    if(filteredTimes.length > 0) {
                                        for(let fc in filteredTimes) {
                                            if(filteredTimes[fc] == movies[m].cinemas[c][s].time_tag) {
                                                time_exists = true
                                            }
                                        }
                                    }

                                    if(filteredMovies.length > 0) {
                                        for(let fm in filteredMovies) {
                                            if(filteredMovies[fm].id == movies[m].id) {
                                                movie_exists = true
                                            }
                                        }
                                    }

                                    if(!time_exists) {
                                        filteredTimes.push(movies[m].cinemas[c][s].time_tag)
                                    }

                                    if(!movie_exists) {
                                        filteredMovies.push(movies[m])
                                    }
                                }                                            
                            }
                        }
                    }
                }
            }
        }

        return {time_tags: filteredTimes, movies: movies}
    }

    getTimesFromMoviesForSelectedCinemaAndTypes(movies, selected_cinema, selected_types) {
        let filteredMovies = []
        let filteredTimes = []

        for(let m in movies) {
            for(let c in movies[m].cinemas) {
                for(let s in movies[m].cinemas[c]) {

                    //filter cinema
                    if(movies[m].cinemas[c][s].cinema.id == selected_cinema.id) {

                        //filter types
                        for(let e in movies[m].cinemas[c][s].experiences) {
                            for(let st in selected_types) {
                                if(movies[m].cinemas[c][s].experiences[e].name == selected_types[st].name) {
                                    let movie_exists = false
                                    let time_exists = false
                                    if(filteredTimes.length > 0) {
                                        for(let fc in filteredTimes) {
                                            if(filteredTimes[fc] == movies[m].cinemas[c][s].time_tag) {
                                                time_exists = true
                                            }
                                        }
                                    }

                                    if(filteredMovies.length > 0) {
                                        for(let fm in filteredMovies) {
                                            if(filteredMovies[fm].id == movies[m].id) {
                                                movie_exists = true
                                            }
                                        }
                                    }

                                    if(!time_exists) {
                                        filteredTimes.push(movies[m].cinemas[c][s].time_tag)
                                    }

                                    if(!movie_exists) {
                                        filteredMovies.push(movies[m])
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        return {time_tags: filteredTimes, movies: movies}
    }

    getTimesFromMoviesForSelectedCinema(movies, selected_cinema) {
        let filteredMovies = []
        let filteredTimes = []

        for(let m in movies) {
            for(let c in movies[m].cinemas) {
                for(let s in movies[m].cinemas[c]) {

                    //filter cinema
                    if(movies[m].cinemas[c][s].cinema.id == selected_cinema.id) {

                        let movie_exists = false
                        let time_exists = false
                        if(filteredTimes.length > 0) {
                            for(let fc in filteredTimes) {
                                if(filteredTimes[fc] == movies[m].cinemas[c][s].time_tag) {
                                    time_exists = true
                                }
                            }
                        }

                        if(filteredMovies.length > 0) {
                            for(let fm in filteredMovies) {
                                if(filteredMovies[fm].id == movies[m].id) {
                                    movie_exists = true
                                }
                            }
                        }

                        if(!time_exists) {
                            filteredTimes.push(movies[m].cinemas[c][s].time_tag)
                        }

                        if(!movie_exists) {
                            filteredMovies.push(movies[m])
                        }
                    }
                }
            }
        }

        return {time_tags: filteredTimes, movies: movies}
    }

    getTimesFromMoviesForSelectedTypesAndGenres(movies, selected_types, selected_genres) {
        let filteredMovies = []
        let filteredTimes = []

        for(let m in movies) {
            for(let c in movies[m].cinemas) {
                for(let s in movies[m].cinemas[c]) {

                    //filter types
                    for(let e in movies[m].cinemas[c][s].experiences) {
                        for(let st in selected_types) {
                            if(movies[m].cinemas[c][s].experiences[e].name == selected_types[st].name) {
                                // console.log(movies[m].cinemas[c][s].cinema.name, selected_types[st].name)
                                //filter genres
                                for(let g in movies[m].genres) {
                                    for(let sg in selected_genres) {
                                        let movie_exists = false
                                        let time_exists = false


                                        if(selected_genres[sg].id == movies[m].genres[g].id) {
                                            if(filteredTimes.length > 0) {
                                                for(let fc in filteredTimes) {
                                                    if(filteredTimes[fc] == movies[m].cinemas[c][s].time_tag) {
                                                        time_exists = true
                                                    }
                                                }
                                            }

                                            if(filteredMovies.length > 0) {
                                                for(let fm in filteredMovies) {
                                                    if(filteredMovies[fm].id == movies[m].id) {
                                                        movie_exists = true
                                                    }
                                                }
                                            }

                                            if(!time_exists) {
                                                filteredTimes.push(movies[m].cinemas[c][s].time_tag)
                                            }

                                            if(!movie_exists) {
                                                filteredMovies.push(movies[m])
                                            }
                                        }                                            
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        return {time_tags: filteredTimes, movies: movies}
    }

    getTimesFromMoviesForSelectedTypes(movies, selected_types) {
        let filteredMovies = []
        let filteredTimes = []

        for(let m in movies) {
            for(let c in movies[m].cinemas) {
                for(let s in movies[m].cinemas[c]) {

                    //filter types
                    for(let e in movies[m].cinemas[c][s].experiences) {
                        for(let st in selected_types) {
                            if(movies[m].cinemas[c][s].experiences[e].name == selected_types[st].name) {
                                let movie_exists = false
                                let time_exists = false
                                if(filteredTimes.length > 0) {
                                    for(let fc in filteredTimes) {
                                        if(filteredTimes[fc] == movies[m].cinemas[c][s].time_tag) {
                                            time_exists = true
                                        }
                                    }
                                }

                                if(filteredMovies.length > 0) {
                                    for(let fm in filteredMovies) {
                                        if(filteredMovies[fm].id == movies[m].id) {
                                            movie_exists = true
                                        }
                                    }
                                }

                                if(!time_exists) {
                                    filteredTimes.push(movies[m].cinemas[c][s].time_tag)
                                }

                                if(!movie_exists) {
                                    filteredMovies.push(movies[m])
                                }
                            }
                        }
                    }
                }
            }
        }

        return {time_tags: filteredTimes, movies: movies}
    }

    getTimesFromMoviesForSelectedGenres(movies, selected_genres) {
        let filteredMovies = []
        let filteredTimes = []

        for(let m in movies) {
            for(let c in movies[m].cinemas) {
                for(let s in movies[m].cinemas[c]) {

                    //filter genres
                    for(let g in movies[m].genres) {
                        for(let sg in selected_genres) {
                            let movie_exists = false
                            let time_exists = false


                            if(selected_genres[sg].id == movies[m].genres[g].id) {
                                if(filteredTimes.length > 0) {
                                    for(let fc in filteredTimes) {
                                        if(filteredTimes[fc] == movies[m].cinemas[c][s].time_tag) {
                                            time_exists = true
                                        }
                                    }
                                }

                                if(filteredMovies.length > 0) {
                                    for(let fm in filteredMovies) {
                                        if(filteredMovies[fm].id == movies[m].id) {
                                            movie_exists = true
                                        }
                                    }
                                }

                                if(!time_exists) {
                                    filteredTimes.push(movies[m].cinemas[c][s].time_tag)
                                }

                                if(!movie_exists) {
                                    filteredMovies.push(movies[m])
                                }
                            }                                            
                        }
                    }
                }
            }
        }

        return {time_tags: filteredTimes, movies: movies}
    }

    getTimesBasedOnFilterSelection(movies, selected_cinema, selected_types, selected_genres, all_time_ranges) {
        switch(true) {
            case (selected_cinema && (selected_types != null  && selected_types.length > 0) && (selected_genres != null  && selected_genres.length > 0)):
                // console.log("getTimes - SET: cinema, types, genres")
                return Promise.resolve(this.getTimesFromMoviesForSelectedCinemaAndTypesAndGenres(movies, selected_cinema, selected_types, selected_genres)).then((data) => {
                    return Promise.resolve(this.separateTimeRanges(data.time_tags, all_time_ranges.items)).then((times) => {
                        return times;
                    })
                })
                
            break;

            case (selected_cinema && (!selected_types ||  selected_types.length == 0) && (selected_genres != null  && selected_genres.length > 0)):
                // console.log("getTimes - SET: cinema, genres")
                // console.log("NOT SET: types")
                return Promise.resolve(this.getTimesFromMoviesForSelectedCinemaAndGenres(movies, selected_cinema, selected_genres)).then((data) => {
                    return Promise.resolve(this.separateTimeRanges(data.time_tags, all_time_ranges.items)).then((times) => {
                        return times;
                    })
                })
            break;

            case (selected_cinema && (selected_types != null  && selected_types.length > 0) && (!selected_genres ||  selected_genres.length == 0)):
                // console.log("getTimes - SET: cinema, types")
                // console.log("NOT SET: genres")

                return Promise.resolve(this.getTimesFromMoviesForSelectedCinemaAndTypes(movies, selected_cinema, selected_types)).then((data) => {
                    return Promise.resolve(this.separateTimeRanges(data.time_tags, all_time_ranges.items)).then((times) => {
                        return times;
                    })
                })
            break;

            case (selected_cinema && (!selected_types ||  selected_types.length == 0) && (!selected_genres ||  selected_genres.length == 0)):
                // console.log("getTimes - SET: cinema")
                // console.log("NOT SET: types, genres")
                return Promise.resolve(this.getTimesFromMoviesForSelectedCinema(movies, selected_cinema)).then((data) => {
                    return Promise.resolve(this.separateTimeRanges(data.time_tags, all_time_ranges.items)).then((times) => {
                        return times;
                    })
                })
            break;

            case (!selected_cinema && (selected_types != null  && selected_types.length > 0) && (selected_genres != null  && selected_genres.length > 0)):
                // console.log("getTimes - SET: types, genres")
                // console.log("NOT SET: cinema")
                return Promise.resolve(this.getTimesFromMoviesForSelectedTypesAndGenres(movies, selected_types, selected_genres)).then((data) => {
                    // console.log(data, selected_types, selected_genres)
                    return Promise.resolve(this.separateTimeRanges(data.time_tags, all_time_ranges.items)).then((times) => {
                        return times;
                    })
                })
            break;

            case (!selected_cinema && (selected_types != null  && selected_types.length > 0) && (!selected_genres || selected_genres.length == 0)):
                // console.log("getTimes - SET: types")
                // console.log("NOT SET: genres, cinema")
                return Promise.resolve(this.getTimesFromMoviesForSelectedTypes(movies, selected_types)).then((data) => {
                    return Promise.resolve(this.separateTimeRanges(data.time_tags, all_time_ranges.items)).then((times) => {
                        return times;
                    })
                })
            break;

            case (!selected_cinema && (!selected_types ||  selected_types.length == 0) && (selected_genres != null  && selected_genres.length > 0)):
                // console.log("getTimes - SET: genres")
                // console.log("NOT SET: types, cinemas")
                return Promise.resolve(this.getTimesFromMoviesForSelectedGenres(movies, selected_genres)).then((data) => {
                    return Promise.resolve(this.separateTimeRanges(data.time_tags, all_time_ranges.items)).then((times) => {
                        return times;
                    })
                })
            break;

            case (!selected_cinema && (!selected_types ||  selected_types.length == 0) && (!selected_genres ||  selected_genres.length == 0)):
                return Promise.resolve(this.separateTimeRanges([], all_time_ranges.items)).then((times) => {
                    return times;
                })
            break;
        }

    }
}

export default new RegionService();


// WEBPACK FOOTER //
// ../hasta-la-vista-middleware-api/src/service/region-service.js